/**
 * Fades + rises each section into view as it scrolls into the viewport.
 * The first section (hero) is excluded via CSS since it animates on load instead.
 * Any other section already partly on screen at load (e.g. peeking below a
 * shorter hero) reveals immediately instead of waiting for a scroll event.
 */
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('scroll-reveal-visible');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0, rootMargin: '0px 0px -5% 0px' }
  );

  const isInViewport = (section) => {
    const rect = section.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  const observeSections = (root = document) => {
    const main = root.querySelector ? root.querySelector('main') : null;
    const sections = main ? main.querySelectorAll(':scope > .shopify-section') : [];
    sections.forEach((section, index) => {
      if (index === 0 || section.classList.contains('scroll-reveal-visible')) return;
      if (isInViewport(section)) {
        section.classList.add('scroll-reveal-visible');
        return;
      }
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeSections());
  } else {
    observeSections();
  }

  // Re-observe when sections are added/reloaded in the theme editor.
  document.addEventListener('shopify:section:load', () => observeSections());
}
